import React, { useState } from 'react'

const t = {
  en: {
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
  },
  es: {
    username: 'Usuario',
    password: 'Contraseña',
    login: 'Ingresar',
    loggingIn: 'Ingresando...'
  }
};

export default function LoginForm({ onLogin, error, lang = 'en' }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    await onLogin(username, password)
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit} className="login-form">
      <input
        type="text"
        value={username}
        placeholder={t[lang]?.username || t.en.username}
        onChange={e => setUsername(e.target.value)}
        required
        autoFocus
        className="login-input"
      />
      <input
        type="password"
        value={password}
        placeholder={t[lang]?.password || t.en.password}
        onChange={e => setPassword(e.target.value)}
        required
        className="login-input"
      />
      {error && <div style={{ color: 'red', fontSize: 14 }}>{error}</div>}
      <button type="submit" disabled={loading} className="login-submit">
        {loading ? (t[lang]?.loggingIn || t.en.loggingIn) : (t[lang]?.login || t.en.login)}
      </button>
    </form>
  )
}
